import { withInstall } from '@touchvue/utils';
import Progress from './src/Progress.vue';

export const ToProgress = withInstall(Progress);
export default ToProgress;

export * from './src/progress';
